/**
 *  @todo This file needs more documentation
 *  @module "form.object.status.util"
 */

define('formkit/form.object.status.util',['require','exports','module','underscore','backbone','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Backbone    = require('backbone'),
      Promise     = require('bluebird');

  var FormObjectStatusUtil = {
    /**
     * @method isDisplayed
     * @param  {Object} model
     * @returns {boolean}  displayed
     */

    isDisplayed: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('displayed');
    },

    /**
     * @method isProgressivelyHidden
     * @param  {Object} model
     * @returns {boolean}    status equals HIDDEN
     */

    isProgressivelyHidden: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == 'HIDDEN';
    },

    /**
     * @method isVisible
     * @param  {Object} model
     * @returns {boolean}   status
     */

    isVisible: function(model) {
      return FormObjectStatusUtil.isDisplayed(model) || !FormObjectStatusUtil.isUnchanged(model);
    },

    /**
     * @method isAdded
     * @param  {Object} model
     * @returns {boolean}   status equals ADDED
     */

    isAdded: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == 'ADDED';
    },

    /**
     * @method isRemoved
     * @param  {Object} model
     * @returns {boolean}   status equals REMOVED
     */

    isRemoved: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == 'REMOVED';
    },

    /**
     * @method isMovedChanged
     * @param  {Object} model
     * @returns {boolean}   status equals MOVED_CHANGED
     */

    isMovedChanged: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == 'MOVED_CHANGED';
    },

    /**
     * @method isUnchanged
     * @param  {Object} model
     * @returns {boolean}   status equals null
     */

    isUnchanged: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == null;
    },

    /**
     * @method isChanged
     * @param  {Object} model
     * @returns {boolean}   status equals CHANGED
     */

    isChanged: function(model) {
      if (!(model instanceof Backbone.Model)) {
        Promise.reject(new Error('model argument must be a Backbone.Model'));
        return;
      }

      return model.get('status') == 'CHANGED';
    },
  };

  module.exports = FormObjectStatusUtil;
});

